// @flow
import { memo } from 'react'

import * as Styled from './styled'

type Props = {|
  children: React$Node,
  className?: string,
  fluid?: boolean,
  textAlign?: 'left' | 'center' | 'right' | 'justified',
|}

export const Container = memo<Props>(function Container({ className, children, fluid = false, textAlign }: Props) {
  return (
    <Styled.Root className={className} fluid={fluid} textAlign={textAlign}>
      {children}
    </Styled.Root>
  )
})
